// SPDX-License-Identifier: LicenseRef-Proprietary

type Key = 'vaccineClient.activity' | 'vaccineClient.inputs' | 'vaccineClient.scenarios' | 'vaccineClient.audience' | 'vaccineClient.disease' | 'vaccineClient.activeTab' | 'vaccineClient.dashboardSettings' | 'vaccineClient.evidenceLibrary' | 'vaccineClient.parameterSources';

export function getItem<T = unknown>(key: Key, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function setItem<T = unknown>(key: Key, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore quota errors in demo
  }
}

export function logActivity(message: string): void {
  try {
    const list = getItem<any[]>('vaccineClient.activity', []);
    const entry = { ts: Date.now(), msg: message };
    const next = [...list, entry].slice(-50);
    setItem('vaccineClient.activity', next);
  } catch {
    // ignore
  }
}

export function cleanupActivityLogs(): void {
  try {
    const list = getItem<any[]>('vaccineClient.activity', []);
    // Filter out any entries that might contain sensitive data
    const cleaned = list.filter(entry => 
      !entry.msg?.toLowerCase().includes('sensitive') && 
      !entry.msg?.toLowerCase().includes('personal')
    );
    if (cleaned.length !== list.length) {
      setItem('vaccineClient.activity', cleaned);
    }
  } catch {
    // ignore
  }
}

// Run cleanup immediately when module loads to clean up any existing entries
cleanupActivityLogs();
